import React from 'react';
import { CalendarIcon, UsersIcon, ClipboardCheckIcon } from 'lucide-react';
import { Button } from '../ui/Button';
export const DayOneToPlan = () => {
  const openCalendly = () => {
    window.open('https://calendly.com/zerototendigital/exploration-feature-design', '_blank');
  };
  return <section className="py-20 bg-white relative overflow-hidden" data-id="element-358">
      {/* Background pattern elements */}
      <div className="absolute bottom-0 right-0 w-72 h-72 bg-purple-50 rounded-full opacity-50 -mr-36 -mb-36" data-id="element-359"></div>
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-360">
        <div className="text-center mb-16" data-id="element-361">
          <p className="text-primary font-medium mb-2" data-id="element-362">FAST ONBOARDING</p>
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-black" data-id="element-363">
            Your Day 1–14 Plan
          </h2>
          <p className="text-xl text-text-secondary max-w-2xl mx-auto" data-id="element-364">
            Here's exactly what happens in your first 14 days with us.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto mb-12" data-id="element-365">
          {/* Day 1-2 */}
          <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-6 relative" data-id="element-366">
            <div className="absolute -top-4 -left-4 w-10 h-10 rounded-full bg-primary text-white flex items-center justify-center font-bold text-lg z-20" data-id="element-367">
              1
            </div>
            <div className="mb-4 flex justify-center" data-id="element-368">
              <CalendarIcon className="w-12 h-12 text-primary" data-id="element-369" />
            </div>
            <div className="text-center mb-4" data-id="element-370">
              <div className="inline-block bg-purple-100 text-primary px-3 py-1 rounded-full text-sm font-medium" data-id="element-371">
                Day 1–2
              </div>
            </div>
            <h3 className="text-xl font-bold mb-3 text-black text-center" data-id="element-372">
              Initial Consultation
            </h3>
            <ul className="space-y-2 text-text-secondary" data-id="element-373">
              <li className="flex items-start" data-id="element-374">
                <span className="inline-block w-1.5 h-1.5 rounded-full bg-primary mt-2 mr-2" data-id="element-375"></span>
                <span data-id="element-376">Founder consult</span>
              </li>
              <li className="flex items-start" data-id="element-377">
                <span className="inline-block w-1.5 h-1.5 rounded-full bg-primary mt-2 mr-2" data-id="element-378"></span>
                <span data-id="element-379"> Project Goals & constraints alignment</span>
              </li>
              <li className="flex items-start" data-id="element-380">
                <span className="inline-block w-1.5 h-1.5 rounded-full bg-primary mt-2 mr-2" data-id="element-381"></span>
                <span data-id="element-382">Tool access setup (Slack/Jira)</span>
              </li>
            </ul>
          </div>
          {/* Day 3-5 */}
          <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-6 relative" data-id="element-383">
            <div className="absolute -top-4 -left-4 w-10 h-10 rounded-full bg-primary text-white flex items-center justify-center font-bold text-lg z-20" data-id="element-384">
              2
            </div>
            <div className="mb-4 flex justify-center" data-id="element-385">
              <UsersIcon className="w-12 h-12 text-primary" data-id="element-386" />
            </div>
            <div className="text-center mb-4" data-id="element-387">
              <div className="inline-block bg-purple-100 text-primary px-3 py-1 rounded-full text-sm font-medium" data-id="element-388">
                Day 3–7
              </div>
            </div>
            <h3 className="text-xl font-bold mb-3 text-black text-center" data-id="element-389">
              Discovery Phase
            </h3>
            <ul className="space-y-2 text-text-secondary" data-id="element-390">
              <li className="flex items-start" data-id="element-391">
                <span className="inline-block w-1.5 h-1.5 rounded-full bg-primary mt-2 mr-2" data-id="element-392"></span>
                <span data-id="element-393">User interviews & data analysis</span>
              </li>
              <li className="flex items-start" data-id="element-394">
                <span className="inline-block w-1.5 h-1.5 rounded-full bg-primary mt-2 mr-2" data-id="element-395"></span>
                <span data-id="element-396">Draft roadmap creation</span>
              </li>
              <li className="flex items-start" data-id="element-397">
                <span className="inline-block w-1.5 h-1.5 rounded-full bg-primary mt-2 mr-2" data-id="element-398"></span>
                <span data-id="element-399">Success metrics definition</span>
              </li>
            </ul>
          </div>
          {/* Day 8-14 */}
          <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-6 relative" data-id="element-400">
            <div className="absolute -top-4 -left-4 w-10 h-10 rounded-full bg-primary text-white flex items-center justify-center font-bold text-lg z-20" data-id="element-401">
              3
            </div>
            <div className="mb-4 flex justify-center" data-id="element-402">
              <ClipboardCheckIcon className="w-12 h-12 text-primary" data-id="element-403" />
            </div>
            <div className="text-center mb-4" data-id="element-404">
              <div className="inline-block bg-purple-100 text-primary px-3 py-1 rounded-full text-sm font-medium" data-id="element-405">
                Day 8–14
              </div>
            </div>
            <h3 className="text-xl font-bold mb-3 text-black text-center" data-id="element-406">
              Execution Kickoff
            </h3>
            <ul className="space-y-2 text-text-secondary" data-id="element-407">
              <li className="flex items-start" data-id="element-408">
                <span className="inline-block w-1.5 h-1.5 rounded-full bg-primary mt-2 mr-2" data-id="element-409"></span>
                <span data-id="element-410">PRDs/epics development</span>
              </li>
              <li className="flex items-start" data-id="element-411">
                <span className="inline-block w-1.5 h-1.5 rounded-full bg-primary mt-2 mr-2" data-id="element-412"></span>
                <span data-id="element-413">Sprint planning</span>
              </li>
              <li className="flex items-start" data-id="element-414">
                <span className="inline-block w-1.5 h-1.5 rounded-full bg-primary mt-2 mr-2" data-id="element-415"></span>
                <span data-id="element-416">Engineering & design kickoff</span>
              </li>
            </ul>
          </div>
        </div>
        {/* Onboarding Checklist Card */}
        <div className="max-w-3xl mx-auto bg-purple-50 rounded-xl p-6 border border-purple-100" data-id="element-417">
          <h3 className="text-xl font-bold mb-4 text-black" data-id="element-418">
            Onboarding Checklist
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-419">
            <div data-id="element-420">
              <h4 className="font-semibold mb-3 text-primary" data-id="element-421">Tools We Join</h4>
              <ul className="space-y-2 text-text-secondary" data-id="element-422">
                <li className="flex items-center" data-id="element-423">
                  <div className="w-1.5 h-1.5 rounded-full bg-primary mr-2" data-id="element-424"></div>
                  <span data-id="element-425">Slack, Teams etc. </span>
                </li>
                <li className="flex items-center" data-id="element-426">
                  <div className="w-1.5 h-1.5 rounded-full bg-primary mr-2" data-id="element-427"></div>
                  <span data-id="element-428">Jira, Liner etc. </span>
                </li>
                <li className="flex items-center" data-id="element-429">
                  <div className="w-1.5 h-1.5 rounded-full bg-primary mr-2" data-id="element-430"></div>
                  <span data-id="element-431">AI prototyping tools </span>
                </li>
                <li className="flex items-center" data-id="element-432">
                  <div className="w-1.5 h-1.5 rounded-full bg-primary mr-2" data-id="element-433"></div>
                  <span data-id="element-434">GitHub</span>
                </li>
              </ul>
            </div>
            <div data-id="element-435">
              <h4 className="font-semibold mb-3 text-primary" data-id="element-436">
                Communication Setup
              </h4>
              <ul className="space-y-2 text-text-secondary" data-id="element-437">
                <li className="flex items-center" data-id="element-438">
                  <div className="w-1.5 h-1.5 rounded-full bg-primary mr-2" data-id="element-439"></div>
                  <span data-id="element-440">Standing ceremonies</span>
                </li>
                <li className="flex items-center" data-id="element-441">
                  <div className="w-1.5 h-1.5 rounded-full bg-primary mr-2" data-id="element-442"></div>
                  <span data-id="element-443">Weekly Communication cadence</span>
                </li>
                <li className="flex items-center" data-id="element-444">
                  <div className="w-1.5 h-1.5 rounded-full bg-primary mr-2" data-id="element-445"></div>
                  <span data-id="element-446">Documentation repositories</span>
                </li>
                <li className="flex items-center" data-id="element-447">
                  <div className="w-1.5 h-1.5 rounded-full bg-primary mr-2" data-id="element-448"></div>
                  <span data-id="element-449">Reporting structure</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        {/* CTA Button */}
        <div className="mt-12 text-center" data-id="element-450">
          <Button variant="primary" onClick={openCalendly} className="text-lg px-8 py-4" data-id="element-451">
            Speak with a Senior PM
          </Button>
        </div>
      </div>
    </section>;
};